import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchUserCoaches, updateUserCoaches, fetchStudentsForCoach, type CoachStudent } from '@data';
import { supabaseClient, useUser } from '@auth-v2';

export const getUserCoachesKey = (userId: string) => ['user-coaches', userId] as const;

export const useUserCoaches = () => {
    const { data: user } = useUser();
    return useQuery({
        queryKey: getUserCoachesKey(user?.id || ''),
        queryFn: () => fetchUserCoaches(supabaseClient, user!.id),
        enabled: !!user,
    });
};

export const useUpdateUserCoaches = (userId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (coachIds: string[]) => {
            return updateUserCoaches(supabaseClient, userId, coachIds);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: getUserCoachesKey(userId) });
        },
    });
};

export const getStudentsForCoachKey = (coachId: string) => ['students', coachId] as const;

export const useStudentsForCoach = (coachId: string) => {
    return useQuery<CoachStudent[]>({
        queryKey: getStudentsForCoachKey(coachId),
        queryFn: () => fetchStudentsForCoach(supabaseClient, coachId),
        enabled: !!coachId,
    });
};
